import classNames from 'clsx';
import React, { useContext } from 'react';

import Translation from '@swf/components/Translation/Translation';

import CreateTournamentContext from '../CreateTournamentContext/CreateTournamentContext';
import Chevron from '../assets/chevron.svg';
import useWizardNav from '../hooks/useWizardNav';
import { ModalPages, ModalPagesNames, ModalPagesRoutes, totalPages } from '../utils/common';

import { TXTCLI_Step_N0 } from './Breadcrumbs.messages.json';
import styles from './Breadcrumbs.scss';

interface Props {
  breadcrumbs?: string[];
}

const Breadcrumbs: React.FC<Props> = ({ breadcrumbs = ModalPagesNames as string[] }) => {
  const {
    state: { activePage }
  } = useContext(CreateTournamentContext);
  const goTo = useWizardNav(activePage, totalPages);

  return (
    <div className={styles.breadcrumbs}>
      {breadcrumbs.map((pageName, index) => {
        const isLast = index + 1 === breadcrumbs.length;
        const isActive = activePage === ModalPages[pageName];
        return (
          <React.Fragment key={pageName}>
            <div
              className={classNames(styles.breadcrumbsItem, { [styles.active]: isActive })}
              onClick={() => goTo(ModalPages[pageName], ModalPagesRoutes[index])}
            >
              <span>
                <Translation {...TXTCLI_Step_N0} values={{ 0: index + 1 }} />
              </span>
            </div>
            {!isLast && <Chevron />}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
